<template>
  <section class="app-main">
    <span class="app-main_bg" :class="bgClass"></span>
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      bgClass() {
        let className = '';
        switch (this.$projectType) {
          case 4:
            className = 'yly';
            break;
          case 5:
            className = 'xjp';
            break;
          case 6:
            className = 'zlgyl';
            break;
        }
        return className
      },
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      },
      logo() {
        return this.$store.state.system.site_logo
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
    background-color: #f5f5f5;

    &_bg {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/static/watermark.png') center center no-repeat;
      background-size: 500px auto;
      opacity: 0.08;

      &.yly {
        background-image: url('~@/static/watermark-yly.png');
      }

      &.xjp {
        background-image: url('~@/static/watermark-zlgyl.png');
      }

      &.zlgyl {
        background-image: url('~@/static/watermark-zlgyl.png');
      }
    }

    >div {
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      background-color: #FFFFFF;

      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 6px;
        border-radius: 6px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      // /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        width: 4px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }

  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AppMain.vue